import React, { useCallback, useEffect, useMemo, useState } from 'react';
import SplitterLayout from 'react-splitter-layout';
import { Column, ColumnFixing } from 'devextreme-react/data-grid';
import notify from 'devextreme/ui/notify';
import { formatMessage } from 'devextreme/localization';
import { Button } from 'devextreme-react/button';
import { DateBox, TextBox } from 'devextreme-react';
import { LoadIndicator } from 'devextreme-react/load-indicator';
import DataGridMVP from '../../DataGridMVP';
import styles from './surveytab.module.scss';
import columnDataSurveys from './columnDataSurveys';
import columnDataSurveyResult from './columnDataSurveyResult';
import { normalizeDateToSend, trim } from '../../../utils/functions';
import HeaderButtonMVP from '../../HeaderButtonMVP';
import PopupMVP from '../../PopupMVP';

const initAddSurveyData = {
  dateFrom: '',
  dateTo: '',
  title: ''
};

const initFocusSurveyModalItems = {
  dateFrom: false,
  dateTo: false,
  title: false
};

const SurveyTab = ({
  surveyReducer: {
    adding,
    addRequest,
    getting,
    listSurveyResult,
    listSurveys
  },
  tabsReducer: { tabSelect },
  userReducer: {
    id
  },
  addSurvey,
  getSurveyResult,
  getListSurveys,
  toggleActivationSurvey
}) => {
  const [filterDataGrid, setFilterDataGrid] = useState({
    dateFrom: '',
    dateTo: '',
    filter: ''
  });
  const [surveyDataGridInstance, setSurveyDataGridInstance] = useState({});
  const [surveyResultDataGridInstance, setSurveyResultDataGridInstance] = useState({});
  const [visibleModalAddSurvey, setVisibleModalAddSurvey] = useState(false);
  const [addSurveyData, setAddSurveyData] = useState(initAddSurveyData);
  const [isSurveyModalValid, setIsSurveyModalValid] = useState(1);
  const [isFocusSurveyModalItems, setIsFocusSurveyModalItems] = useState(initFocusSurveyModalItems);
  const [selectedSurveyId, setSelectedSurveyId] = useState();

  useEffect(() => {
    if ((id !== null) && (tabSelect === 5)) {
      getListSurveys(filterDataGrid);
    }
  }, [getListSurveys, filterDataGrid, id, tabSelect]);

  useEffect(() => {
    if (addRequest) {
      notify(
        {
          message: formatMessage('dataSuccess'),
          height: 64,
          width: 354,
          position: {
            at: 'top center',
            my: 'top center',
            offset: '0 48'
          }
        },
        'success',
        2000
      );
      surveyDataGridInstance.instance.clearSelection();
      surveyResultDataGridInstance.instance.clearSelection();
      setVisibleModalAddSurvey(false);
    }
  }, [
    addRequest,
    surveyDataGridInstance.instance,
    surveyResultDataGridInstance.instance
  ]);

  const openModalAddSurvey = useCallback(() => {
    setVisibleModalAddSurvey(true);
  }, []);

  const onHidingModalAddSurvey = useCallback(() => {
    setAddSurveyData(initAddSurveyData);
    setVisibleModalAddSurvey(false);
  }, []);

  const sendAddSurvey = useCallback(() => {
    setIsSurveyModalValid(1);
    if (trim(addSurveyData.title, ' ') === '') {
      setIsSurveyModalValid(0);
    } else {
      addSurvey({
        dateFromFilter: addSurveyData.dateFrom,
        dateToFilter: addSurveyData.dateTo,
        ...addSurveyData
      });
      setAddSurveyData(initAddSurveyData);
    }
  }, [addSurvey, addSurveyData]);

  /** Поисковая строка */
  const dataGridOnOptionChanged = useCallback(({ value, name }) => {
    if (name === 'searchPanel') {
      setFilterDataGrid({ ...filterDataGrid, filter: value });
    }
  }, [filterDataGrid]);

  // Обновление данных
  const onClickUpdate = useCallback(() => {
    getListSurveys({
      ...filterDataGrid
    });
  }, [filterDataGrid, getListSurveys]);

  const onSelectSurvey = useCallback(
    ({ selectedRowsData }) => {
      if (selectedRowsData && selectedRowsData.length) {
        getSurveyResult({
          surveyNumId: selectedRowsData[0].surveyNumId
        });

        setSelectedSurveyId(selectedRowsData[0]);
      }
    },
    [getSurveyResult]
  );

  const renderColumnsDataGridSurvey = useMemo(
    () =>
      columnDataSurveys.map((item) => {
        if (item.dataField === 'isActiveFlag') {
          return (
            <Column
              dataField={item.dataField}
              caption={item.caption}
              visible={!item.notVisible}
              allowSearch={false}
              calculateCellValue={(rowData) => rowData.isActiveFlag === 'Y'}
              allowFiltering
              cellRender={item.cellRender}
              key={item.dataField}
              dataType={item.dataType}
              cssClass={item.cssClass}
              width={item.width ? item.width : undefined}
            />
          );
        }
        return (
          <Column
            dataField={item.dataField}
            caption={item.caption}
            visible={!item.notVisible}
            allowSearch={false}
            allowFiltering
            cellRender={item.cellRender}
            key={item.dataField}
            dataType={item.dataType}
            cssClass={item.cssClass}
            width={item.width ? item.width : undefined}
          />
        );
      }),
    []
  );

  const renderSurveyList = useMemo(() => (
    <>
      <HeaderButtonMVP headButtVisibol={{ display: 'flex', width: '50%' }}>
        <Button text={formatMessage('textButton').addSurvey}
                type="default"
                stylingMode="contained"
                onClick={() => openModalAddSurvey()}
        />
        {selectedSurveyId
          && (
          <Button text={selectedSurveyId.isActiveFlag === 'Y' ? formatMessage('textButton').complete : formatMessage('textButton').resume}
                            type={selectedSurveyId.isActiveFlag === 'Y' ? 'danger' : 'success'}
                            stylingMode="contained"
                            onClick={() => {
                              toggleActivationSurvey({
                                surveyNumId: selectedSurveyId.surveyNumId, ...filterDataGrid
                              });
                              setSelectedSurveyId(null);
                            }}

          />
          )}
      </HeaderButtonMVP>
      <DataGridMVP className="incoming"
                 dataGridOnOptionChanged={dataGridOnOptionChanged}
                 dataSource={listSurveys}
                 filterDataGrid={filterDataGrid}
                 setFilterDataGrid={setFilterDataGrid}
                 keyExpr="surveyNumId"
                 loading={getting}
                 loadingData={getting}
                 onSelectionChanged={onSelectSurvey}
                 selectionMode="single"
                 setDataGridInstance={setSurveyDataGridInstance}
                 setStateStoringName={'dataGridSurvey'}
                 showBorders
                 tText="Период опроса"
                 onClickUpdate={onClickUpdate}
                 visibleButtonUpdate
                 // visibleButtonDateRangePicker={false}
                 // visibleFilter={false}
                 visibleFilterPanel={false}
                 visibleGroupPanel={false}
                 // visibleHeaderFilter={false}
                 visibleInfoIcon={false}
                 // visibleSearchPanel={false}
                 visibleSummary={false}
      >
        { renderColumnsDataGridSurvey }
      </DataGridMVP>
    </>
  ), [
    dataGridOnOptionChanged,
    listSurveys,
    filterDataGrid,
    getting,
    onSelectSurvey,
    onClickUpdate,
    renderColumnsDataGridSurvey,
    openModalAddSurvey,
    selectedSurveyId,
    toggleActivationSurvey
  ]);

  const renderColumnsDataGridSurveyResult = useMemo(() => (
    columnDataSurveyResult.map(
      (item) => (
        <Column dataField={item.dataField}
                caption={item.caption}
                visible={!item.notVisible}
                allowSearch={false}
                allowFiltering
                cellRender={item.cellRender}
                key={item.dataField}
                dataType={item.dataType}
                cssClass={item.cssClass}
                width={item.width ? item.width : undefined}
        />
      )
    )
  ), []);

  const renderSurveyResultList = useMemo(() => (
    <>
      <DataGridMVP className="shipment"
                   dataSource={listSurveyResult}
                   filterDataGrid
                   keyExpr="surveyResultNumId"
                   loadingData={getting}
                   selectionMode="single"
                   setDataGridInstance={setSurveyResultDataGridInstance}
                   visibleButtonDateRangePicker={false}
                   visibleFilter={false}
                   visibleFilterPanel={false}
                   visibleGroupPanel={false}
                   visibleHeaderFilter={false}
                   visibleInfoIcon={false}
                   visibleSearchPanel={false}
                   visibleSummary={false}
      >
        <ColumnFixing enabled />
        { renderColumnsDataGridSurveyResult }
      </DataGridMVP>
    </>
  ), [listSurveyResult, getting, renderColumnsDataGridSurveyResult]);

  const renderModalAddSurvey = useMemo(() => (
    <PopupMVP visible={visibleModalAddSurvey}
              onHiding={onHidingModalAddSurvey}
              title={formatMessage('textButton').addSurvey}
    >
      <div className="formData">
        <div className="optionsRow">
          <div className="optionsData">
            <span>{formatMessage('textModal').surveyStartDate}</span>
            <DateBox type="date"
                     displayFormat="dd.MM.yyyy"
                     value={addSurveyData.dateFrom}
                     onValueChanged={({ value }) => setAddSurveyData({
                       ...addSurveyData,
                       dateFrom: normalizeDateToSend(value)
                     })}
                     width="100%"
                     stylingMode="outlined"
                     openOnFieldClick
                     useMaskBehavior
                     onFocusIn={() => setIsFocusSurveyModalItems({
                       ...initFocusSurveyModalItems,
                       dateFrom: true
                     })}
                     isValid={isFocusSurveyModalItems.dateFrom
                       || (trim(addSurveyData.dateFrom, ' ') !== '')
                       || !!isSurveyModalValid}
                     validationError={{ message: formatMessage('textError').enterDate }}
            />
          </div>
          <div className="optionsData">
            <span>{formatMessage('textModal').surveyEndDate}</span>
            <DateBox type="date"
                     displayFormat="dd.MM.yyyy"
                     value={addSurveyData.dateTo}
                     onValueChanged={({ value }) => setAddSurveyData({
                       ...addSurveyData,
                       dateTo: normalizeDateToSend(value)
                     })}
                     width="100%"
                     stylingMode="outlined"
                     openOnFieldClick
                     useMaskBehavior
                     onFocusIn={() => setIsFocusSurveyModalItems({
                       ...initFocusSurveyModalItems,
                       dateTo: true
                     })}
                     isValid={isFocusSurveyModalItems.dateTo
                       || (trim(addSurveyData.dateTo, ' ') !== '')
                       || !!isSurveyModalValid}
                     validationError={{ message: formatMessage('textError').enterDate }}
            />
          </div>
        </div>
        <div className="optionsRow">
          <div className="optionsData">
            <span>{formatMessage('textModal').surveyTitle}</span>
            <TextBox stylingMode="outlined"
                     placeholder="Введите описание опроса"
                     value={addSurveyData.title}
                     onValueChanged={({ value }) => setAddSurveyData({
                       ...addSurveyData,
                       title: value
                     })}
                     onFocusIn={() => setIsFocusSurveyModalItems({
                       ...initFocusSurveyModalItems,
                       title: true
                     })}
                     isValid={isFocusSurveyModalItems.title
                       || (trim(addSurveyData.title, ' ') !== '')
                       || !!isSurveyModalValid}
                     validationError={{ message: formatMessage('textError').fieldNotFilled }}
            />
          </div>
        </div>
        <div className="formButton">
          <Button text="Отмена"
                  type="default"
                  stylingMode="text"
                  onClick={onHidingModalAddSurvey}
          />
          <Button type="default"
                  stylingMode="contained"
                  onClick={sendAddSurvey}
                  width={200}
          >
            <LoadIndicator className="indicator" visible={adding} />
            <span>Сохранить</span>
          </Button>
        </div>
      </div>
    </PopupMVP>
  ), [
    visibleModalAddSurvey,
    onHidingModalAddSurvey,
    addSurveyData,
    isFocusSurveyModalItems.dateFrom,
    isFocusSurveyModalItems.dateTo,
    isFocusSurveyModalItems.title,
    isSurveyModalValid,
    sendAddSurvey,
    adding
  ]);

  return (
    <div className={styles.containing}>
      <SplitterLayout>
        <div>
          <p><b>Опросы</b></p>
          {renderSurveyList}
        </div>
        <div>
          <p><b>Результаты опросов</b></p>
          {renderSurveyResultList}
        </div>
      </SplitterLayout>
      {renderModalAddSurvey}
    </div>
  );
};

export default SurveyTab;
